<template>
  <div class="foters">
    <div class="form">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="用户名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入用户名"
                v-model="conditionLike.userName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="用户账号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入用户账号"
                :allowClear="true"
                v-model="conditionLike.userCode"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fw">
            <a-form-item
              label="用户状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                :allowClear="true"
                v-model="conditionLike.userStatus"
                placeholder="请选择用户状态"
              >
                <a-select-option
                  v-for="item in usrTpList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="padding-top: 2.4%; margin-left: 12px">
              <a-button type="primary" @click="queryList(1)">查询</a-button>
              <a-button type="primary" ghost @click="userAdd()" style="margin-left: 15px;">添加</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <div>
        <a-table
          :columns="columns"
          :scroll="{ x: 1000, y: 'calc(100vh - 250px)' }"
          :data-source="tableData"
          :pagination="false"
          :loading="Tableloading"
          :rowKey="
            (record, index) => {
              return record.id;
            }
          "
          bordered
          size="small"
        >
          <div slot="index" slot-scope="text, record, index">
            {{ index + (pageNum - 1) * pageSize + 1 }}
          </div>

          <span slot="deptId" slot-scope="text, record">
            {{ record.deptId | capitalize(record.deptId) }}
          </span>
          <span slot="userStatus" slot-scope="text, record">
            <span v-if="record.userStatus == 1"><a-badge color="cyan" /></span>
            <span v-else-if="record.userStatus == 2"
              ><a-badge color="red"
            /></span>
            <span v-else-if="record.userStatus == 3"
              ><a-badge color="red"
            /></span>
            {{ record.userStatus | DictionaryFilter("USER_STATUS") }}
          </span>
          <span slot="userType" slot-scope="text, record">
            {{ record.userType | DictionaryFilter("USER_TYPE") }}
          </span>
          <div slot="action" slot-scope="text, record">
            <a v-show = "record.userStatus == 3" @click="cancellockUserFn(text)">解除冻结</a>
            <a @click="modification(text)">编辑</a>
            <a @click="deleteClick(text)">删除</a>
            <a @click="up(text)">{{
                      text.userStatus == 1 ? "禁用" : "启用"
                    }}</a>
            <a @click="guser(text)">分配角色</a>
            <a @click="resetPasswordFn(text)">重置密码</a>
          </div>
        </a-table>
      </div>
      <!-- 分页 -->
      <div class="base-pagination">
        <a-pagination
        class="table_pagination"
        show-size-changer
        :default-current="1"
        v-model="pageNum"
        :show-total="(totalRows) => `共 ${totalRows} 条`"
        :page-size-options="pageSizeOptions"
        size="small"
        :total="totalRows"
        @showSizeChange="onShowSizeChange"
        @change="paginationChange"
        :page-size.sync="pageSize"
        />
      </div>
    </div>
    <!-- 新增弹窗 -->
    <addModal
      v-if="visible"
      :visible="visible"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></addModal>
  </div>
</template>

<script>
import {
  userquery,
  userdelete,
  rolequery,
  getroles,
  deptList,
  addrole,
  userresetpassword,
  institutionsLIst,
  userStatus,
  unlockUser,
  resetPwd,
  defaultPwd,
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import addModal from "./user-add-modal.vue";
let that = this;
export default {
  name: "userManagement",
  components: {
    addModal: addModal,
  },
  data() {
    return {
      formLayout: "horizontal",
      bmList: [],
      conditionLike: {
        userCode: "",
        userName: "",
        userStatus: undefined,
      },
      Tableloading: false,
      usrTpList: [],
      tableData: [],
      querying: false,
      staing: false,
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 23,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "用户名",
          align: "center",
          dataIndex: "userName",
          width: 65,
          key: "userName",
          ellipsis: true,
          scopedSlots: { customRender: "userName" },
        },
        {
          title: "用户账号",
          align: "center",
          dataIndex: "userCode",
          width: 65,
          key: "userCode",
          ellipsis: true,
        },
        {
          title: "手机号",
          align: "center",
          dataIndex: "phoneNo",
          width: 65,
          key: "phoneNo",
          ellipsis: true,
        },
        {
          title: "部门",
          align: "center",
          dataIndex: "deptId",
          width: 65,
          key: "deptId",
          ellipsis: true,
          scopedSlots: { customRender: "deptId" },
        },
        {
          title: "用户状态",
          align: "center",
          dataIndex: "userStatus",
          width: 40,
          key: "userStatus",
          ellipsis: true,
          scopedSlots: { customRender: "userStatus" },
        },
        {
          title: "用户类型",
          align: "center",
          dataIndex: "userType",
          width: 40,
          key: "userType",
          ellipsis: true,
          scopedSlots: { customRender: "userType" },
        },
        {
          title: "登录错误次数",
          align: "center",
          dataIndex: "loginCount",
          width: 50,
          key: "loginCount",
          ellipsis: true,
          scopedSlots: { customRender: "loginCount" },
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 115,
          scopedSlots: { customRender: "action" },
        },
      ],
      // // 分页相关
      pageNum: 1,
      pageSize: 10,
      totalRows: null,
      totalPage: "",
      pageSizeOptions: ["10", "20", "50", "100"],
      //新增弹框
      visible: false,
      userData: {},
      type: "",
      // title:'',
      // userid:"",
    };
  },
  beforeCreate() {
    that = this;
  },
  mounted() {
    const list = [];
    deptList().then((res) => {
      res.content.forEach(
        (element) => {
          list.push({ id: element.id, deptName: element.deptName });
        },
        (err) => {
          this.$message.error("查询失败");
        }
      );
      this.bmList = list;
    });
    DictionaryService.getAllNeedDic(["USER_STATUS","USER_TYPE"]).then((res) => {
      this.usrTpList = DictionaryService.getOptions("USER_STATUS");
      this.queryList();
    });
  },
  filters: {
    capitalize: function (value, list) {
      let str = "";
      that.bmList.forEach((element) => {
        if (element.id == value) {
          str = element.deptName;
        }
      });
      return str;
    },
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    //重置密码操作
    resetPasswordFn(text) {
      const h = this.$createElement;
      defaultPwd().then((res)=>{
        this.defPassword =  res.content;
        this.$confirm({
          title: "确定是否重置密码?",
          okText: "是",
          cancelText: "否",
          content: () =>
          h('span', {}, [
            h( 'span',
              { 
                style: { color: 'red' },
              },
              '默认密码：'+this.defPassword,
            ),
          ]),
          onOk: () => {
            this.querying = true;
            resetPwd({ id: text.id }).then(
              (res) => {
                this.querying = false;
                this.queryList();
                this.$message.success("设置成功");
              },
              (err) => {
                this.querying = false;
              }
            );
          },
          onCancel: () => {},
        });
      }).catch((err) => {
        if (err.message) {
          this.$message.error(err.message);
        } else {
          this.$message.error("网络请求异常");
        }
      });
    },
    //解除冻结操作
    cancellockUserFn(text) {
      this.$confirm({
        title: "确定是否解决冻结?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          this.querying = true;
          unlockUser({ id: text.id }).then(
            (res) => {
              this.querying = false;
              this.queryList();
              this.$message.success("设置成功");
            },
            (err) => {
              this.querying = false;
            }
          );
        },
        onCancel: () => {},
      });
    },
    // 分页修改
    paginationChange(page, pageSize) {
      this.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.queryList();
    },
    handleMenuClick(e) {
    },
    up(list) {
      let status = list.userStatus;
      this.$confirm({
        title: status == 1 ? "确认禁用吗？" : "确认启用吗？",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          this.staing = true;

          userStatus({ id: list.id }).then(
            (res) => {
              this.staing = false;
              this.queryList();
              this.$message.success("设置成功");
            },
            (err) => {
              this.staing = false;
              this.$message.error("设置失败");
            }
          );
        },
        onCancel: () => {},
      });
    },
    down() {},
    // 获取表格数据
    queryList(sum = 2) {
      if (sum == 1) this.pageNum = 1;
      this.Tableloading = true;
      let pageParam = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderBy: "",
      };
      userquery({ pageParam: pageParam, content: this.conditionLike }).then(
        (res) => {
          this.Tableloading = false;
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPage = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {
          this.$message.error("查询失败");
          this.Tableloading = false;
        }
      );
    },
    // 用户添加
    userAdd() {
      this.visible = true;
      this.type = "add";
      this.title = "用户添加";
    },
    // 关闭弹窗
    reflush(value) {
      this.visible = value;
    },
    // 用户删除
    deleteClick(text) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          this.querying = true;
          userdelete({ id: text.id }).then(
            (res) => {
              this.querying = false;
              this.pageNum = 1;
              this.queryList();
              this.$message.success("设置成功");
            },
            (err) => {
              this.querying = false;
            }
          );
        },
        onCancel: () => {},
      });
    },
    // 用户修改
    modification(data) {
      this.visible = true;
      this.type = "amend";
      this.userData = data;
      this.title = "用户修改";
    },
    guser(index) {
      //配置跳转页面
      this.$router.push({
        path: "/home/user/assignRoles",
        query: { id: index.id },
      });
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.foters {
  width: 100%;
  height: 100%;
  overflow-y: hidden ;
  .title-name {
    width: 100%;
    height: 100px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 12px;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
}

/deep/ .ant-table-body {
  //   max-height: 487px;
  //   overflow: auto;
  // margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/deep/ .form .ant-input,
.ant-select,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 236px;
}
.oper {
  // flex: 1;
  width: 200px;
}
.ant-row {
  display: flex;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 75px;
}
/deep/ .ant-col-18 {
  width: 75%;
}

.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.base-pagination{
  float: right;
}
.base-content{
  margin-top: 10px;
}

</style>
